var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChoose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.99106065,1.46303656 C4.3816671,1.46303656 1.44516817,4.39953548 1.44516817,8.00892903 C1.44516817,11.618357 4.3816671,14.5548215 7.99106065,14.5548215 C11.6004542,14.5548215 14.5369531,11.618357 14.5369531,8.00892903 C14.5369531,4.39953548 11.6004542,1.46303656 7.99106065,1.46303656 M7.99106065,15.9999828 C5.85655742,15.9999828 3.84984774,15.1687742 2.34051441,13.6594753 C0.831215484,12.1501763 6.88172031e-06,10.1434323 6.88172031e-06,8.00892903 C6.88172031e-06,5.87446022 0.831215484,3.86775054 2.34051441,2.3583828 C3.84984774,0.849083871 5.85659183,0.0178752688 7.99106065,0.0178752688 C10.1255295,0.0178752688 12.1322735,0.849083871 13.6416069,2.3583828 C15.1509058,3.86775054 15.9821144,5.87446022 15.9821144,8.00892903 C15.9821144,10.1433978 15.1509058,12.1501763 13.6416069,13.6594753 C12.1322735,15.1687742 10.1255295,15.9999828 7.99106065,15.9999828",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45242105,6.3542947 C0.976222129,6.22022953 0.603102856,6.04950031 0.333333333,5.84249847 L0.809566014,4.96840009 C1.08726993,5.16013612 1.42449872,5.31341403 1.82145495,5.42842955 C2.21824236,5.54344507 2.61908138,5.60095283 3.02383696,5.60095283 C4.02384118,5.60095283 4.52384329,5.32489601 4.52384329,4.77284761 C4.52384329,4.58884235 4.4563165,4.44326258 4.3214655,4.33581473 C4.18641192,4.22852997 4.01786506,4.15001541 3.81548727,4.1000427 C3.61310948,4.0502657 3.32537783,3.9947151 2.95242738,3.93326041 C2.44442334,3.85673562 2.02980886,3.76850051 1.70834758,3.6687508 C1.38695382,3.5691642 1.11107313,3.40042475 0.880975593,3.16266294 C0.650709242,2.92509685 0.535744884,2.59156489 0.535744884,2.16203444 C0.535744884,1.61001866 0.773810579,1.16717955 1.25004326,0.833647585 C1.72620841,0.500115624 2.36497807,0.333333333 3.16668988,0.333333333 C3.58724672,0.333333333 4.00783733,0.383306044 4.42856299,0.482860034 C4.84915359,0.582609739 5.1943843,0.716838005 5.46428888,0.885414355 L4.97620525,1.75951274 C4.46023305,1.43749538 3.85309969,1.27645408 3.15480516,1.27645408 C2.67060432,1.27645408 2.30153666,1.3532072 2.04763593,1.50648512 C1.79356639,1.65995875 1.66671731,1.86304628 1.66671731,2.11604128 C1.66671731,2.31554069 1.73812689,2.47260244 1.88097981,2.58758534 C2.02383274,2.70263348 2.20034776,2.78708475 2.41076124,2.84064558 C2.62090461,2.89436951 2.91667194,2.9556611 3.29762432,3.02468346 C3.80542578,3.10913473 4.21615747,3.19913128 4.52978564,3.29493405 C4.84321124,3.39089992 5.11105625,3.55373528 5.33335444,3.78373371 C5.55545004,4.01376475 5.66666667,4.33581473 5.66666667,4.74985103 C5.66666667,5.30189943 5.42265861,5.74092209 4.93454122,6.0667559 C4.44645759,6.39275282 3.78162258,6.55555556 2.9405089,6.55555556 C2.42450294,6.55555556 1.92861996,6.48832726 1.45242105,6.3542947",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/status/choose",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/gray_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4C4C4E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "palette/gray_5",
    mask: "url(#mask-2)",
    fill: "#4C4C4E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.000000, -29.000000)",
    id: "color/gray_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 88,
    height: 78
  })))), /*#__PURE__*/React.createElement("g", {
    id: "color/gray_5",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4C4C4E",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "palette/gray_5",
    mask: "url(#mask-4)",
    fill: "#4C4C4E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.000000, -36.000000)",
    id: "color/gray_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 88,
    height: 78
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoose);
export default __webpack_public_path__ + "static/media/choose.02154df3.svg";
export { ForwardRef as ReactComponent };